import WorkFlow from './workflow.vue'
import WorkbenchHeader from './workbench-header'
import WorkbenchBody from './workbench-body'

WorkFlow.install = Vue => {
  Vue.component(WorkFlow.name, WorkFlow)
}

WorkbenchHeader.install = Vue => {
  Vue.component(WorkbenchHeader.name, WorkbenchHeader)
}

WorkbenchBody.install = Vue => {
  Vue.component(WorkbenchBody.name, WorkbenchBody)
}

export {
  CardLayout,
  WorkFlow,
  WorkbenchHeader,
  WorkbenchBody,
}



// WEBPACK FOOTER //
// ./src/components/layouts/index.js